import type { z } from "zod";

import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import {
  CulturalObjectSchema,
  CulturalObjectsDtoSchema,
  CulturalObjectsPageDtoSchema,
  CulturalObjectsTypesDtoSchema,
} from "./schemas";
import type {
  CulturalObject,
  CulturalObjectsPageType,
  CulturalObjectsPoints,
  CulturalObjectsType,
} from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToCulturalObjectsPage = (
  dto: unknown,
): CulturalObjectsPageType => {
  const parsed = safeParseWithFallback(
    CulturalObjectsPageDtoSchema,
    dto,
    "mapDtoToCulturalObjectsPage",
  );

  return extractData(parsed, dto, dto as CulturalObjectsPageType);
};

export const mapDtoToCulturalObjectsPoints = (
  dto: unknown,
): CulturalObjectsPoints => {
  const parsed = safeParseWithFallback(
    CulturalObjectsDtoSchema,
    dto,
    "mapDtoToCulturalObjectsPoints",
  );

  const rawData = extractDataWithMeta<
    z.infer<typeof CulturalObjectSchema>[],
    CulturalObjectsPoints["meta"]
  >(parsed, dto, defaultMeta as CulturalObjectsPoints["meta"]);

  // Return the data directly without EquipmentPointItem transformation
  // since CulturalObject has different structure than EquipmentPointItem
  return {
    data: rawData.data,
    meta: rawData.meta,
  };
};

export const mapDtoToCulturalObjectPoint = (dto: unknown): CulturalObject[] => {
  const parsed = safeParseWithFallback(
    CulturalObjectSchema,
    dto,
    "mapDtoToCulturalObjectPoint",
  );

  return extractData(parsed, dto, []);
};

export const mapDtoToCulturalObjectsTypes = (
  dto: unknown,
): CulturalObjectsType[] => {
  const parsed = safeParseWithFallback(
    CulturalObjectsTypesDtoSchema,
    dto,
    "mapDtoToCulturalObjectsTypes",
  );

  return extractData(parsed, dto, []);
};
